import { Box, Typography, TextField, IconButton,Button, Switch } from "@mui/material";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import React, { useCallback, useEffect, useRef} from "react";
import {
  resetNodesState,
} from "../../../redux/features/nodes";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  updateNodeLabel,
  deleteNode,
  updateNodeWidth,
  updateNodeHeight,
  Nodes
} from "../../../redux/features/nodes";
import { updatePlotHeight, updatePlotWidth } from "../../../redux/features/nodes";
import { resetRoomState } from "../../../redux/features/room/room.slice";
import { toggleUnit } from "../../../redux/features/appState";
import { showToast } from "../../../redux/features/toast/toast.slice";


const CustomDiv = styled.div`
  .container {
    width: 100%;
    height: calc(100vh - 170px);
    display: flex;
    flex-direction: column;
    background: #FBE5C6;
    font-family: Poppins;
    border-radius: 12px;
    padding: 0;
    border: 2px solid #1a1a1a;
    overflow: hidden;
  }
  .header {
    font-size: 18px;
    font-weight: 700;
    color: #1a1a1a;
    background-color: #FF9A56;
    padding: 16px;
    text-align: center;
    border-bottom: 2px solid #1a1a1a;
  }
  .scroll-container {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
  }
  .row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px;
    margin-bottom: 12px;
    background: white;
    border: 2px solid #1a1a1a;
    border-radius: 10px;
    transition: all 0.1s ease;
    &:hover {
      transform: translate(-1px, -1px);
    }
  }
  .header-row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 10px;
    margin-bottom: 16px;
    font-weight: 700;
    color: #1a1a1a;
    border-bottom: 2px solid #1a1a1a;
    text-transform: uppercase;
    font-size: 13px;
    letter-spacing: 0.5px;
    position: sticky;
    top: 0;
    z-index: 1;
    color: #1a1a1a;
  }
  .bottom-row{
  display:flex;
  }
  .directions {
  color: #FF9A56;
  font-size: 16px;
  line-height: 1.8;
  padding: 8px 16px;
  font-weight: 500;
  text-align: left;
}


`;

const LeftSidebar = () => {
  const dispatch = useDispatch<AppDispatch>();
  const nodes = useSelector((state: RootState) => state.nodesState.nodes);
  const isDimensioned = useSelector((state: RootState) => state.graph.dimensioned);

  const handleDeleteNode = (nodeId: number) => {
    dispatch(deleteNode(nodeId));
  };

  const handleLabelChange = (nodeId: number, newLabel: string) => {
    dispatch(updateNodeLabel({ id: nodeId, label: newLabel }));
  };

  const handleWidthChange = (nodeId: number, value: string) => {
    let cleaned = value.replace(/[^0-9]/g, "");
    if (cleaned.startsWith("0")) {
      cleaned = cleaned.replace(/^0+/, "");
    }
    
    if (cleaned === "") {
      dispatch(showToast({ message: "Dimension cannot be empty or null", type: "error" }));
      dispatch(updateNodeWidth({ id: nodeId, max: isDimensioned ? 0 : 99999, min: 0 }));
      return;
    }

    const numValue = parseInt(cleaned, 10);
    if (!isNaN(numValue) && numValue > 0) {
      dispatch(
        updateNodeWidth({
          id: nodeId,
          max: isDimensioned ? numValue : 99999,
          min: numValue,
        }),
      );
    }
  };

  const handleHeightChange = (nodeId: number, value: string) => {
    let cleaned = value.replace(/[^0-9]/g, "");
    if (cleaned.startsWith("0")) {
      cleaned = cleaned.replace(/^0+/, "");
    }

    if (cleaned === "") {
      dispatch(showToast({ message: "Dimension cannot be empty or null", type: "error" }));
      dispatch(updateNodeHeight({ id: nodeId, max: isDimensioned ? 0 : 99999, min: 0 }));
      return;
    }

    const numValue = parseInt(cleaned, 10);
    if (!isNaN(numValue) && numValue > 0) {
      dispatch(
        updateNodeHeight({
          id: nodeId,
          max: isDimensioned ? numValue : 99999,
          min: numValue,
        }),
      );
    }
  };

  const handleReload = useCallback(() => {
    console.log("refresh triggered");
    dispatch(resetNodesState());
    dispatch(resetRoomState());
  }, [dispatch]);

  const isFirstRender = useRef(true);
    const plotWidth = useSelector((state: any) => state.nodesState.plotWidth);
    const plotHeight = useSelector((state: any) => state.nodesState.plotHeight);
  
    const unit = useSelector(
      (state: RootState) => state.outputEditorButtonState.unit,
    );
    const handleToggleDimensions = useCallback(() => {
      dispatch(toggleUnit());
    }, [dispatch]);
  
    const getDimensionInSelectedUnit = (dimension: number) => {
      const feetToMeters = 0.3048;
      const metersToFeet = 1 / feetToMeters;
      return unit === "meters"
        ? Math.round(dimension * feetToMeters)
        : Math.round(dimension * metersToFeet);
    };
  
  
    useEffect(() => {
  if (isFirstRender.current) {
    isFirstRender.current = false;
    return;
  }

  if (plotWidth > 0) {
    dispatch(updatePlotWidth(getDimensionInSelectedUnit(plotWidth)));
  }
  if (plotHeight > 0) {
    dispatch(updatePlotHeight(getDimensionInSelectedUnit(plotHeight)));
  }
      nodes.forEach((node: Nodes) => {
        const newMinWidth = getDimensionInSelectedUnit(node.width.min);
        const newMinHeight = getDimensionInSelectedUnit(node.height.min);
  
        // Update minWidth
        dispatch(
          updateNodeWidth({
            id: node.id,
            max: isDimensioned ? newMinWidth : node.width.max,
            min: newMinWidth,
          }),
        );
  
        // Update minHeight
        dispatch(
          updateNodeHeight({
            id: node.id,
            max: isDimensioned ? newMinHeight : node.height.max,
            min: newMinHeight,
          }),
        );
      });
    }, [unit]);
  

  return (
    <Box
      sx={{
        width: "20vw",
        height: "calc(100vh - 170px)",
        margin: "8px 0px 0px 8px",
        overflowY: "scroll",
        overflowX: "hidden",
        "-ms-overflow-style": "none" /* IE and Edge */,
        scrollbarWidth: "none" /* Firefox */,
      }}
    >
      <CustomDiv>
        <Box className="container">
          <Typography className="header">Dimension Input</Typography>

          <div className="scroll-container">
            <div className="header-row">
              <div style={{ width: "40px" }} />
              <div style={{ flex: 2 }}>Node</div>
              <div style={{ flex: 1, textAlign: "center" }}>Width</div>
              <div style={{ flex: 1, textAlign: "center" }}>Height</div>
            </div>
            {nodes.length === 0 ? (
  <div className="row" style={{
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}>
    <IconButton size="small" sx={{ width: "40px" }}>
      <DeleteIcon fontSize="small" />
    </IconButton>

    <TextField
      size="small"
      placeholder="Enter label..."
      sx={{
        flex: 2,
        "& .MuiInputBase-input": {
          backgroundColor: "#f8f9fa",
          borderRadius: "4px",
          padding: "8px",
        },
      }}
    />

    <TextField
      size="small"
      placeholder="Min width"
      sx={{
        flex: 1,
        "& .MuiInputBase-input": {
          backgroundColor: "#f8f9fa",
          borderRadius: "4px",
          padding: "8px",
          textAlign: "center",
        },
      }}
    />

    <TextField
      size="small"
      placeholder="Min height"
      sx={{
        flex: 1,
        "& .MuiInputBase-input": {
          backgroundColor: "#f8f9fa",
          borderRadius: "4px",
          padding: "8px",
          textAlign: "center",
        },
      }}
    />
    <div className="directions">
      <p>1. Click anywhere on the screen to create a node.</p>
      <p>2. Join two nodes together by dragging an edge between them.</p>
    </div>
  </div>
) : (
  nodes.map((node) => (
    <div className="row" key={node.id}>
      <IconButton
        size="small"
        color="error"
        onClick={() => handleDeleteNode(node.id)}
        sx={{ width: "40px" }}
      >
        <DeleteIcon fontSize="small" />
      </IconButton>

      <TextField
        size="small"
        value={node.label}
        onChange={(e) => handleLabelChange(node.id, e.target.value)}
        sx={{
          flex: 2,
          "& .MuiInputBase-input": {
            backgroundColor: "white",
            borderRadius: "6px",
            padding: "8px",
            fontFamily: "Poppins",
            fontSize: "13px",
            fontWeight: 500,
            border: "1px solid rgba(0,0,0,0.1)",
          },
        }}
      />

<TextField
  size="small"
  value={node.width?.min === 0 ? "" : (node.width?.min || 3)}
  onChange={(e) => handleWidthChange(node.id, e.target.value)}
  sx={{
    flex: 1,
    "& .MuiInputBase-input": {
      backgroundColor: "#f8f9fa",
      borderRadius: "4px",
      padding: "8px",
      textAlign: "center",
    },
  }}
  inputProps={{
    type: "text",
    inputMode: "numeric",
    pattern: "[0-9]*"
  }}
/>


      <TextField
        size="small"
        value={node.height?.min === 0 ? "" : (node.height?.min || 3)}
        onChange={(e) => handleHeightChange(node.id, e.target.value)}
        sx={{
          flex: 1,
          "& .MuiInputBase-input": {
            backgroundColor: "#f8f9fa",
            borderRadius: "4px",
            padding: "8px",
            textAlign: "center",
          },
        }}
        inputProps={{
          type: "text",
          inputMode: "numeric",
          pattern: "[0-9]*"
        }}
      />
    </div>
  ))
)}
          </div>
          <div className="bottom-row">
            <Box
                  sx={{
                    width: "50vw",
                    borderColor: "#1a1a1a",
                    display: "flex",
                    alignItems: "center",
                    padding: "10px",
                    borderRadius: "0 0 0 8px",
                    border: "2px solid #1a1a1a",
                    borderLeft: "none",
                    borderBottom: "none",
                  }}
                >
                  <Typography
                    sx={{
                      color: unit === "feet" ? "#1a1a1a" : "#666666",
                      fontSize: "14px",
                      fontWeight: 700,
                      fontFamily: "Poppins",
                    }}
                  >
                    Feet
                  </Typography>
                  <Switch
                    checked={unit === "meters"}
                    onChange={handleToggleDimensions}
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "#FF9A56",
                      },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                        backgroundColor: "#FF9A56",
                      },
                    }}
                  />
                  <Typography
                    sx={{
                      color: unit === "meters" ? "#1a1a1a" : "#666666",
                      fontSize: "14px",
                      fontWeight: 700,
                      fontFamily: "Poppins",
                      pl: 1,
                    }}
                  >
                    Meters
                  </Typography>
                </Box>
          
          <Button
            variant="outlined"
            sx={{
              border: "2px solid #1a1a1a",
              borderRight: "none",
              borderBottom: "none",
              width:"50vw",
              color: "#1a1a1a", 
              padding:  "12px 20px",
              borderRadius: "0 0 8px 0",
              backgroundColor: "#FF9A56",
              position: "relative",
              fontWeight: 700,

              "&:hover": {
                backgroundColor: "#e8894d",
              },
              // Text styles
            }}
            onClick={handleReload}
          >
            <span >Reset </span>
          </Button></div>
          
        </Box>
      </CustomDiv> 
    </Box>
  );
};

export default LeftSidebar;
